import { AIServicesAvailabilityInterface, AIServicesAvailabilityResponseInterface, AIServicesSummary } from '@dashart/dashart-gpt-shared-library';
import { BaseService } from './BaseService';

/**
 * Service for fetching AI services availability information.
 * Provides access to comprehensive service status and statistics.
 */
export class AiServicesAvailabilityService extends BaseService {
    
    private static instance: AiServicesAvailabilityService;

    /**
     * Gets the singleton instance of AiServicesAvailabilityService.
     * @returns The singleton instance.
     */
    public static getInstance(): AiServicesAvailabilityService {
        if (!AiServicesAvailabilityService.instance) {
            AiServicesAvailabilityService.instance = new AiServicesAvailabilityService();
        }
        return AiServicesAvailabilityService.instance;
    }

    protected getConfiguration(): { defaultModel: string, apiResourceName: string } {
        return {
            defaultModel: '',
            apiResourceName: 'ai-services'
        };
    }

    /**
     * Fetches comprehensive AI services availability information.
     * @returns Promise resolving to AIServicesAvailabilityInterface containing all services data.
     */
    public async getAiServicesAvailability(): Promise<AIServicesAvailabilityResponseInterface> {
        await this.checkSessionValidity();
        
        const response = await this.axiosInstance.get(
            `/v1/ai-services/available`,
            { headers: this.getDefaultHeaders() }
        );
        
        await this.checkResponseStatus(response);
        return response.data as AIServicesAvailabilityResponseInterface;
    }

    /**
     * Fetches summary statistics for AI services availability.
     * @returns Promise resolving to AIServicesSummary containing aggregate statistics.
     */
    public async getAiServicesSummary(): Promise<AIServicesSummary> {
        const availabilityData = await this.getAiServicesAvailability();
        return availabilityData.data.summary;
    }
}